<template>
  <Card v-bind="$attrs">
    <template #title="">
      Line Notification Log
    </template>
    <template #subtitle="">
      แสดง Log การส่งข้อความแจ้งเตือนไปยัง Line ของผู้ใช้งาน
    </template>
    <template #content="">
      <div class="p-grid">
        <div class="p-col-5 p-fluid p-field">
          <span class="p-float-label">
            <Calendar
              name="cal"
              selectionMode="range"
              v-model="dates"
            ></Calendar>
            <label for="cal">ระบุวันที่ค้นหา</label>
          </span>
        </div>
        <div class="p-col-5 p-fluid p-field">
          <span class="p-float-label">
            <InputText name="userId" v-model="userId"></InputText>
            <label for="userId">ระบุรหัสพนักงานที่ต้องการค้นหา</label>
          </span>
        </div>
        <div class="p-col-1">
          <Button label="ค้นหา" icon="pi pi-search" @click="loadLogs"></Button>
        </div>
        <div class="p-col-12">
          <DataTable :value="notificationLogs" paginator :rows="10">
            <template #empty="">ไม่พบข้อมูล</template>
            <Column field="id" header="Id" sortable></Column>
            <Column field="userId" header="User Id" sortable></Column>
            <Column field="notificationOn" header="แจ้งเมื่อ" sortable>
              <template #body="props">
                {{ formatAppDateTime(props.data.notificationOn) }}
              </template>
            </Column>
            <Column field="apiResponse" header="API Response" sortable>
              <template #body="props">
                <Tag v-if="!props.data.apiResponse" severity="warning"
                  >N/A
                </Tag>
                <Tag
                  severity="success"
                  v-else-if="props.data.apiResponse.indexOf('Successful') >= 0"
                >
                  ส่งข้อความสำเร็จ
                </Tag>
                <Tag
                  v-else
                  v-tooltip="`${props.data.apiResponse}`"
                  severity="danger"
                  >Error</Tag
                >
              </template>
            </Column>
            <Column headerStyle="width: 12rem" bodyStyle="width:12rem">
              <template #body="props">
                <Button
                  label="ดูรายละเอียด"
                  icon="pi pi-eye"
                  @click="popupDetail(props.data)"
                ></Button>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </template>
  </Card>
  <Dialog v-model:visible="showDialog" modal>
    <div class="p-grid">
      <div class="p-col-12 p-fluid">
        <label for="message">ข้อความที่ส่งไปยัง Line</label>
        <Textarea
          name="message"
          :rows="8"
          :modelValue="JSON.stringify(message ?? 'N/A')"
          readonly
        ></Textarea>
      </div>
      <div class="p-col-12 p-fluid">
        <label for="response">ผลลัพธ์การส่ง</label>
        <Textarea
          name="response"
          :rows="8"
          :modelValue="
            JSON.stringify(notificationLog?.apiResponse ?? 'N/A', null, 2)
          "
          readonly
        ></Textarea>
      </div>
    </div>
  </Dialog>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { usePlugin } from "@/plugins";
import {
  NotificationLog,
  GetNotificationLogRequest,
  GetNotificationLogResponse,
} from "@/types";

export default defineComponent({
  name: "Notification Log",
  setup() {
    const notificationLogs = ref<NotificationLog[]>([]);
    const notificationLog = ref<NotificationLog>();
    const dates = ref<Date[]>([]);
    const userId = ref("");
    const showDialog = ref(false);
    const message = ref();

    const {
      axios,
      error,
      success,
      dayjs,
      setLoading,
      formatAppDateTime,
    } = usePlugin();

    const loadLogs = async () => {
      setLoading(true);
      try {
        var result = await axios.post<GetNotificationLogResponse>(
          "api/v1/services/notificationLogs/get",
          {
            dates: dates.value,
            userId: userId.value,
          } as GetNotificationLogRequest
        );
        notificationLogs.value = result.data.logs ?? [];
        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const popupDetail = (log: NotificationLog) => {
      notificationLog.value = log;
      showDialog.value = true;
      message.value = JSON.parse(
        notificationLog.value.message.replaceAll('\\"', '"')
      );
    };

    onMounted(async () => {
      dates.value = [
        dayjs()
          .add(-7, "day")
          .toDate(),
        dayjs()
          .add(7, "day")
          .toDate(),
      ];
      await loadLogs();
    });

    return {
      notificationLogs,
      dates,
      userId,
      loadLogs,
      formatAppDateTime,
      notificationLog,
      popupDetail,
      showDialog,
      message,
    };
  },
});
</script>

<style></style>
